(() => {
  const SELECTORS = {
    root: '.buyMe',
    countrySpan: '.buyMe-left h6 span',
    early: '.buyMe_early_dates',
    late: '.buyMe_late_dates',
    money: '.buyMe .price__current .money',
    original: '.buyMe .price__current .original_price',
    discount: '.buyMe-right .isDiscount',
    buyNowBtn: '.buyMe .atc-button',
    variantIdInput: 'form[action*="/cart/add"] [name="id"]',
    triggerAnchor: '.product_livechat'
  };

  const root = document.querySelector(SELECTORS.root);
  if (!root) return;

  const discountEl = root.querySelector(SELECTORS.discount);

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function formatUSShort(d) {
    // Keep behavior consistent with old code: Intl.DateTimeFormat('en-US', {month:'short', day:'numeric'})
    try {
      return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(d);
    } catch {
      return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    }
  }

  function computeDates(isUS) {
    const currentDate = new Date();
    const days = (n) => new Date(currentDate.getTime() + n * 24 * 60 * 60 * 1000);
    const early = isUS ? days(3) : days(7);
    const late = isUS ? days(5) : days(10);
    return { early: formatUSShort(early), late: formatUSShort(late) };
  }

  const IPINFO_CACHE_KEY = 'cs_ipinfo_country_v1';
  const IPINFO_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

  function readIpinfoCache() {
    try {
      const raw = sessionStorage.getItem(IPINFO_CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed?.country || Date.now() - parsed.ts > IPINFO_CACHE_TTL_MS) return null;
      return String(parsed.country);
    } catch {
      return null;
    }
  }

  function writeIpinfoCache(country) {
    try {
      sessionStorage.setItem(IPINFO_CACHE_KEY, JSON.stringify({ country, ts: Date.now() }));
    } catch {
      // ignore quota errors
    }
  }

  function applyCountryAndDates(abbr) {
    let fullName = 'USA';
    let isUS = abbr === 'US';

    if (isUS) {
      fullName = 'USA';
    } else {
      const maybe = typeof convertAbbreviationToFullName === 'function'
        ? convertAbbreviationToFullName(abbr)
        : 'false';
      if (maybe && maybe !== 'false') {
        fullName = maybe;
      } else {
        fullName = 'USA';
        isUS = true;
      }
    }

    const { early, late } = computeDates(isUS);
    const countrySpan = root.querySelector(SELECTORS.countrySpan);
    const earlyEl = root.querySelector(SELECTORS.early);
    const lateEl = root.querySelector(SELECTORS.late);
    if (countrySpan) countrySpan.textContent = fullName;
    if (earlyEl) earlyEl.textContent = early;
    if (lateEl) lateEl.textContent = late;
  }

  async function fetchCountryFromIpinfo() {
    const resp = await fetch('https://ipinfo.io/json');
    const data = await resp.json();
    return data?.country ? String(data.country) : '';
  }

  async function setCountryAndDates() {
    const cached = readIpinfoCache();
    if (cached) {
      applyCountryAndDates(cached);
      return;
    }

    applyCountryAndDates('US');

    const load = async () => {
      try {
        const abbr = await fetchCountryFromIpinfo();
        if (abbr) {
          writeIpinfoCache(abbr);
          applyCountryAndDates(abbr);
        }
      } catch {
        // keep USA default
      }
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(load, { timeout: 3000 });
    } else {
      window.setTimeout(load, 1500);
    }
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, '').trim();
  }

  function getPlainMoneyFormat() {
    const raw = typeof window.shopMoneyFormat === 'string' ? window.shopMoneyFormat : '${{amount}}';
    const stripped = stripHtml(raw);
    return stripped || '${{amount}}';
  }

  function formatCents(cents) {
    const fmt = getPlainMoneyFormat();
    const amount = (Number(cents) / 100).toFixed(2);
    const amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formatted = fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amountWithCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(Number(cents) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'));

    return stripHtml(formatted);
  }

  function getCurrentVariant() {
    const p = window.ShopifyProduct;
    if (!p || !Array.isArray(p.variants)) return null;

    const input = document.querySelector(SELECTORS.variantIdInput);
    const id = input ? Number(input.value) : null;
    if (!id) return p.variants.find(v => v && v.available) || p.variants[0] || null;
    return p.variants.find(v => Number(v.id) === id) || null;
  }

  function readDiscountValue() {
    // Prefer in-DOM value (copied from metafield), fallback to global bfDiscount
    const text = discountEl ? discountEl.textContent : '';
    const num = Number(String(text || '').trim());
    if (Number.isFinite(num) && num > 0) return num;
    const global = Number(window.bfDiscount || 0);
    return Number.isFinite(global) && global > 0 ? global : 0;
  }

  function getMainQuantity() {
    const qtyInput =
      document.querySelector('.product-form__quantity .quantity__input') ||
      document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function calculateBundleTotalCents(variant) {
    const mainQty = getMainQuantity();
    const basePriceCents = variant ? Number(variant.price) || 0 : 0;
    const compareAtCents =
      variant && Number(variant.compare_at_price) > basePriceCents
        ? Number(variant.compare_at_price)
        : basePriceCents;

    let totalCents = basePriceCents * mainQty;
    let totalCompareCents = compareAtCents * mainQty;

    document.querySelectorAll('.accessory-items .accessory-item').forEach((row) => {
      const checkbox = row.querySelector('.accessory-checkbox');
      const qtyInput = row.querySelector('.accessory-qty');
      if (checkbox?.checked) {
        const price = parseInt(checkbox.dataset.price, 10) || 0;
        const qty = parseInt(qtyInput?.value, 10) || 1;
        totalCents += price * qty;
        totalCompareCents += price * qty;
      }
    });

    const discount = readDiscountValue();
    const discountCents = discount > 0 ? Math.round(discount * 100) * mainQty : 0;
    const displayCents = Math.max(0, totalCents - discountCents);

    let compareCents = 0;
    if (discountCents > 0) {
      compareCents = totalCents;
    } else if (totalCompareCents > totalCents) {
      compareCents = totalCompareCents;
    }

    return { displayCents, compareCents };
  }

  function updatePrice(variantOverride) {
    if (typeof window.updateProductBundlePrice === 'function' && document.querySelector('.bundle-current_price')) {
      window.updateProductBundlePrice();
      return;
    }

    const variant = variantOverride || getCurrentVariant();
    const moneyEls = root.querySelectorAll(SELECTORS.money);
    const originalEls = root.querySelectorAll(SELECTORS.original);
    if (!variant || moneyEls.length === 0) return;

    if (document.querySelector('.bundle-current_price')) {
      const { displayCents, compareCents } = calculateBundleTotalCents(variant);
      moneyEls.forEach((el) => {
        el.textContent = formatCents(displayCents);
      });
      originalEls.forEach((el) => {
        el.textContent = compareCents > displayCents ? formatCents(compareCents) : '';
      });
      document.querySelectorAll('.bundle-current_price').forEach((el) => {
        el.textContent = formatCents(displayCents);
      });
      document.querySelectorAll('.bundle-original_price').forEach((el) => {
        if (compareCents > displayCents) {
          el.textContent = formatCents(compareCents);
          el.style.removeProperty('display');
        } else {
          el.style.display = 'none';
        }
      });
      return;
    }

    const discount = readDiscountValue();
    const basePriceCents = Number(variant.price || 0);
    const compareAtCents = Number(variant.compare_at_price || 0);

    let currentCents = basePriceCents;
    let originalCents = compareAtCents > basePriceCents ? compareAtCents : 0;

    if (discount > 0) {
      currentCents = Math.max(0, basePriceCents - Math.round(discount * 100));
      originalCents = basePriceCents;
    }

    moneyEls.forEach((el) => {
      el.textContent = formatCents(currentCents);
    });

    originalEls.forEach((el) => {
      el.textContent = originalCents > currentCents ? formatCents(originalCents) : '';
    });
  }

  function setupBundlePriceSync() {
    if (!document.querySelector('.bundle-current_price')) return;

    const qtyInput =
      document.querySelector('.product-form__quantity .quantity__input') ||
      document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    if (qtyInput) {
      qtyInput.addEventListener('change', () => updatePrice());
      qtyInput.addEventListener('input', () => updatePrice());
    }
  }

  function isBuyNowAvailable(variantOverride) {
    const submitBtn = document.querySelector('.bundle-add-to-cart-btn');
    if (submitBtn) return !submitBtn.disabled;

    const input = document.querySelector(SELECTORS.variantIdInput);
    if (input?.disabled) return false;

    const variant = variantOverride || getCurrentVariant();
    return Boolean(variant?.available);
  }


function updateBuyNowState(variantOverride) {
  const btn = root.querySelector(SELECTORS.buyNowBtn);
  if (!btn) return;

  const available = isBuyNowAvailable(variantOverride);
  const soldOutLabel = window.variantStrings?.soldOut || 'Sold out';
  const buyNowLabel = btn.dataset.buyNowLabel || 'Buy Now';

  // Buy Now
  btn.disabled = !available;
  btn.setAttribute('aria-disabled', available ? 'false' : 'true');
  btn.classList.toggle('product-card-buy-action--sold-out', !available);
  btn.textContent = available ? buyNowLabel : soldOutLabel;

  // Add to Cart
  const addBtn = root.querySelector('.cs-buyme-add-to-cart');

  if (addBtn && addBtn.getAttribute('aria-busy') !== 'true') {
    addBtn.disabled = !available;
    addBtn.setAttribute('aria-disabled', String(!available));
    addBtn.classList.toggle(
      'product-card-buy-action--sold-out',
      !available
    );
    addBtn.textContent = available ? 'Add to Cart' : soldOutLabel;
  }
}


  function setupVariantObserver() {
    const input = document.querySelector(SELECTORS.variantIdInput);
    if (input) {
      input.addEventListener('change', () => {
        updatePrice();
        updateBuyNowState();
      });
      input.addEventListener('input', () => {
        updatePrice();
        updateBuyNowState();
      });

      const obs = new MutationObserver(() => {
        updatePrice();
        updateBuyNowState();
      });
      obs.observe(input, { attributes: true, attributeFilter: ['value', 'disabled'] });
    }

    const submitBtn = document.querySelector('.bundle-add-to-cart-btn');
    if (submitBtn) {
      const submitObs = new MutationObserver(() => updateBuyNowState());
      submitObs.observe(submitBtn, { attributes: true, attributeFilter: ['disabled'] });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        updatePrice(event?.data?.variant);
        updateBuyNowState(event?.data?.variant);
      });
    }
  }

  function getCartItems() {
    const items = [];
    const mainVariantInput = document.querySelector(SELECTORS.variantIdInput);
    const qtyElement =
      document.querySelector('form[action*="/cart/add"] [name="quantity"]') ||
      document.querySelector('.quantity__input');

    if (mainVariantInput && mainVariantInput.value && !mainVariantInput.disabled) {
      items.push({
        id: parseInt(mainVariantInput.value, 10),
        quantity: qtyElement ? parseInt(qtyElement.value, 10) || 1 : 1
      });
    }

    const accessoryContainer = document.querySelector('.accessory-items');
    if (accessoryContainer) {
      accessoryContainer.querySelectorAll('.accessory-checkbox:checked').forEach((checkbox) => {
        const variantId = checkbox.dataset.variantId;
        const qtyInput = checkbox.closest('.accessory-item')?.querySelector('.accessory-qty');
        if (variantId) {
          items.push({
            id: parseInt(variantId, 10),
            quantity: parseInt(qtyInput?.value, 10) || 1
          });
        }
      });
    }

    return items.filter((item) => Number.isFinite(item.id) && item.id > 0);
  }

  function getCartAddUrl() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    if (window.routes?.cart_add_url) {
      const url = window.routes.cart_add_url;
      return url.endsWith('.js') ? url : `${url}.js`;
    }
    return `${rootUrl}cart/add.js`;
  }

  function getCartPageUrl() {
    return window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
  }

  function getCheckoutUrl() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    return `${rootUrl}checkout`;
  }

  async function clearCart() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    await fetch(`${rootUrl}cart/clear.js`, { method: 'POST' });
  }

  async function addItemsToCart(items) {
    const addUrl = getCartAddUrl();
    const payload = items.length === 1 ? items[0] : { items };
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      let message = 'Add to cart failed';
      try {
        const data = await response.json();
        message = data.description || data.message || message;
      } catch {}
      throw new Error(message);
    }

    return response.json();
  }

async function refreshAndOpenCartDrawer() {
  const drawer = document.querySelector('cart-drawer');

  // Dawn-compatible cart drawer refresh
  if (drawer && typeof drawer.renderContents === 'function') {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const sectionIds = typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(s => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];

    const response = await fetch(
      `${rootUrl}?sections=${encodeURIComponent(sectionIds.join(','))}`
    );

    if (!response.ok) throw new Error('Cart refresh failed');

    const sections = await response.json();

drawer.renderContents({
  sections,
  id: null
});

    return;
  }

  // Fallback if theme drawer is not available
  window.location.href = getCartPageUrl();
}

function setupAddToCart() {
  const btn = root.querySelector('.cs-buyme-add-to-cart');
  if (!btn) return;

  const originalLabel = 'Add to Cart';

  btn.addEventListener('click', async () => {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') {
      return;
    }

    const items = getCartItems();

    if (!items.length || !isBuyNowAvailable()) {
      return;
    }

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding...';

    try {
      // Do NOT clear existing cart
      await addItemsToCart(items);

      btn.textContent = 'Added';

      // Refresh drawer after successful add
      await refreshAndOpenCartDrawer();

    } catch (error) {
      console.error('Buy Me Add to Cart:', error);

      // If add succeeded but drawer refresh failed,
      // the product may already be in the cart.
      // Do not retry automatically.
      alert(error.message || 'Unable to update cart. Please check your cart.');

    } finally {
      btn.removeAttribute('aria-busy');
      btn.textContent = originalLabel;
      updateBuyNowState();
      btn.disabled = !isBuyNowAvailable();
      btn.setAttribute('aria-disabled', String(btn.disabled));
    }
  });
}

  function setupBuyNow() {
    const btn = root.querySelector(SELECTORS.buyNowBtn);
    if (!btn) return;

    btn.addEventListener('click', async () => {
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

      const items = getCartItems();
      if (items.length === 0) return;

      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      try {
        localStorage.setItem('buyMeCart', 'true');
      } catch {}

      try {
        await clearCart();
        await addItemsToCart(items);
        window.location.href = getCheckoutUrl();
      } catch (error) {
        console.error('Buy Now failed:', error);
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function setupScrollToggle() {
    const purchaseBlock = document.querySelector('.product-form-buyBtns');
    const priceEl = document.querySelector('.product__info-container [id^="price-"]');

    const isPurchaseBlockHidden = () => {
      if (!purchaseBlock) return null;

      let bottom = purchaseBlock.getBoundingClientRect().bottom;
      if (priceEl && !purchaseBlock.contains(priceEl)) {
        bottom = Math.max(bottom, priceEl.getBoundingClientRect().bottom);
      }
      return bottom <= 0;
    };

    const updateVisibility = () => {
      const hidden = isPurchaseBlockHidden();
      if (hidden === null) {
        const anchor = document.querySelector(SELECTORS.triggerAnchor);
        if (!anchor) return;
        const rect = anchor.getBoundingClientRect();
        const threshold =
          rect.top + (window.scrollY || 0) + (window.innerWidth > 1024 ? 80 : 120);
        root.style.display = (window.scrollY || 0) >= threshold ? 'block' : 'none';
        return;
      }

      root.style.display = hidden ? 'block' : 'none';
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    window.addEventListener('load', updateVisibility, { passive: true });
    updateVisibility();
  }

  // old behavior: clear flag on each product page load
  try {
    if (localStorage.getItem('buyMeCart')) localStorage.removeItem('buyMeCart');
  } catch {}

  setCountryAndDates();
  updatePrice();
  updateBuyNowState();
  setupVariantObserver();
  setupBundlePriceSync();
setupBuyNow();
setupAddToCart();
setupScrollToggle();
})();

